<template>
  <v-dialog
    v-model="showDialog"
    max-width="600"
    scrollable
  >
    <template v-slot:activator="{ on }">
      <v-btn
        data-cy="btn_concordo_com_produtor"
        outlined
        class="mr-1"
        :class="$vuetify.breakpoint.mdAndUp ? '' : 'mb-3'"
        color="primary"
        :width="$vuetify.breakpoint.mdAndUp ? '50%' : '100%'"
        :max-width="$vuetify.breakpoint.mdAndUp ? '234' : ''"
        :disabled="validacaoStatus()"
        v-on="on"
      >
        Desistir da solicitação
      </v-btn>

      <v-btn
        data-cy="btn_discordo_do_produtor"
        outlined
        color="primary"
        :width="$vuetify.breakpoint.mdAndUp ? '50%' : '100%'"
        :max-width="$vuetify.breakpoint.mdAndUp ? '234' : ''"
        :disabled="validacaoStatus()"
        :to="urlRotaDiscordo"
        v-on="on"
      >
        Prosseguir
      </v-btn>
    </template>
    <v-card data-cy="modal_concordo_com_produtor">
      <v-card-title
        class="title pt-5 pb-0"
        primary-title
        data-cy="modal_titulo_concordo_com_produtor"
      >
        Desistir da solicitação
      </v-card-title>

      <v-card-text
        class="pt-2 pb-9"
        data-cy="modal_texto_concordo_com_produtor"
      >
        <p class="mb-0">
          Ao cancelar sua solicitação de reembolso pela Plataforma Monetizze,
          você está ciente que o prazo de arrependimento
          (30 dias contados da data da compra) continuará a ocorrer. Assim,
          caso ainda esteja dentro do prazo e queira pedir novamente, a
          devolução do valor pago, entre em contato com o Suporte Monetizze
          pelo e-mail: suporte@monetizze.com.br
        </p>
      </v-card-text>

      <v-card-actions class="pt-9">
        <v-spacer />
        <v-btn
          color="primary"
          text
          data-cy="modal_btn_nao_concordo_com_produtor"
          @click="showDialog = false"
        >
          Cancelar
        </v-btn>

        <v-btn
          color="primary"
          text
          data-cy="modal_btn_sim_concordo_com_produtor"
          :loading="loading"
          @click="concordarComProdutor()"
        >
          Concluir
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api';

export default {
  name: 'ConsumidorRespondeReversaoProdutor',

  props: {
    statusReembolso: {
      type: String,
      required: true,
    },

    codigoReembolso: {
      type: Number,
      required: true,
    },

    codigoVenda: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      showDialog: false,
      loading: false,
      statusAtivo: ['aguardando-resposta-consumidor'],
      urlMinhasCompras: '/minhas-compras/detalhe-compra/',
      urlRotaConcordo: '/refund-request/agree/',
      urlRotaDiscordo: '/acompanhar-solicitacao-reembolso/motivos-discordar',
    };
  },

  methods: {
    async concordarComProdutor() {
      let sucesso = true;
      this.loading = true;

      try {
        await api.post(`${this.urlRotaConcordo}`, {
          order: this.codigoVenda,
          refund_request_id: this.codigoReembolso,
        });
      } catch (error) {
        sucesso = false;
      }

      this.loading = false;

      this.$emit('repostaApi', sucesso);
      this.showDialog = false;
      this.$router.go(0);
    },

    validacaoStatus() {
      if (this.statusAtivo.includes(this.statusReembolso)) {
        return false;
      }

      return true;
    },
  },
};
</script>
